import React, { useState, useRef, useEffect } from 'react';
import { useT } from '../context/I18nContext';
import { ChevronDown, Globe } from 'lucide-react';

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, langs } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = langs.find((l) => l.code === lang) || langs[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div ref={ref} className="relative" data-testid="lang-switcher">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-zinc-300 hover:text-[#d4af37] text-sm h-9 px-2 rounded transition-colors"
        aria-label="Change language"
        data-testid="lang-switcher-trigger"
      >
        {compact ? <Globe className="h-4 w-4" /> : <span className="text-lg leading-none">{current.flag}</span>}
        <span className="hidden md:inline uppercase tracking-wider text-xs">{current.code}</span>
        <ChevronDown className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-zinc-950 border border-zinc-800 rounded shadow-xl z-50 overflow-hidden" data-testid="lang-switcher-menu">
          {langs.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => { setLang(l.code); setOpen(false); }}
              data-testid={`lang-option-${l.code}`}
              className={`w-full text-left flex items-center gap-3 px-3 py-2 text-sm hover:bg-zinc-900 transition-colors ${l.code === lang ? 'text-[#d4af37]' : 'text-zinc-200'}`}
            >
              <span className="text-base">{l.flag}</span>
              <span>{l.label}</span>
              {l.code === lang && <span className="ml-auto text-xs">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
